export type ShopifyResourceType = 'product' | 'collection' | 'page';

export type ShopifyResource = {
  type: ShopifyResourceType;
  handle: string;
};

// Order matters: /collections/<handle>/products/<handle> also starts with
// /collections/, so the product pattern must be tried before the plain
// collection one.
const RESOURCE_PATTERNS: Array<{
  type: ShopifyResourceType;
  regex: RegExp;
}> = [
  { type: 'product', regex: /^\/collections\/[^/]+\/products\/([^/?#]+)/ },
  { type: 'product', regex: /^\/products\/([^/?#]+)/ },
  { type: 'collection', regex: /^\/collections\/([^/?#]+)/ },
  { type: 'page', regex: /^\/pages\/([^/?#]+)/ }
];

// Blogs, cart, account, search, and the homepage itself don't reduce to a
// single handle lookup the same way - they fall back to the homepage
// unchanged, same as before this resolver existed.
export const parseShopifyResourcePath = (
  pathname: string
): ShopifyResource | null => {
  for (const { type, regex } of RESOURCE_PATTERNS) {
    const match = pathname.match(regex);
    if (match) {
      return { type, handle: match[1] };
    }
  }
  return null;
};
